import React from 'react';
import NewsColumn from './NewsColumn';

/**
 * Interface for a news link
 */
interface NewsLink {
  title: string;
  url: string;
  highlight: boolean;
  imageSrc?: string;
  fullImageSrc?: string;
  comment?: string;
}

/**
 * Interface for a news category
 */
interface NewsCategory {
  name: string;
  links: NewsLink[];
}

/**
 * Props for the MainContent component
 */
interface MainContentProps {
  categories: Array<{
    name: string;
    links: Array<{
      title: string;
      url: string;
      highlight: boolean;
      imageSrc?: string;
      fullImageSrc?: string;
      comment?: string;
    }>;
  }>;
}

/**
 * MainContent component that renders multiple NewsColumn components
 */
const MainContent: React.FC<MainContentProps> = ({ categories }) => {
  // Add error handling for missing categories
  if (!categories || !Array.isArray(categories)) {
    return (
      <div className="main-content error">
        <p>No categories available. Please check your data source.</p>
      </div>
    );
  }

  return (
    <div className="main-content">
      {categories.map((category, index) => (
        <NewsColumn 
          key={index}
          categoryName={category.name}
          links={category.links || []} // Add fallback for missing links
        />
      ))}
    </div>
  );
};

export default MainContent; 